export const ADDRESS_API_PATHS = {
  root: '/addresses',
  item: (id: string) => `/addresses/${encodeURIComponent(id)}`,
} as const

export const ADDRESS_PATHS = {
  list: '/profile/addresses',
  nestedList: 'addresses',
  nestedEdit: 'addresses/:id',
  edit: (id: string) => `/profile/addresses/${id}`,
} as const

export const ADDRESS_UI = {
  heading: 'Saved addresses',
  lead: 'Showing saved addresses with the same pincode as your delivery area.',
  useNew: 'Use a new address',
  pageTitle: 'Addresses',
  pageLead: 'Addresses you have used are stored here and can be chosen at checkout.',
  checkoutEmpty: 'Add a delivery address in your account before checkout.',
  manage: 'Manage addresses',
  emptyTitle: 'No saved addresses yet',
  emptyHint: 'Add one here. Checkout will use it as-is.',
  addTitle: 'Add address',
  addLead: 'This address is saved for later orders. You can edit it anytime.',
  edit: 'Edit',
  editAria: (name: string) => `Edit address for ${name}`,
  delete: 'Delete',
  deleteAria: (name: string) => `Delete address for ${name}`,
  deleteConfirm: 'Delete this address?',
  deleteYes: 'Yes, delete',
  deleteCancel: 'Keep',
  deleting: 'Deleting…',
  deleteError: 'Could not delete this address.',
  editTitle: 'Edit address',
  editLead: 'Update this saved address. Checkout uses the new details.',
  missing: 'This address is no longer available.',
  back: 'Back to addresses',
  backToCheckout: 'Back to checkout',
  save: 'Save address',
  saving: 'Saving…',
  name: 'Recipient name',
  phone: 'Recipient phone',
  address: 'House, flat, street',
  city: 'City',
  pincode: 'Pincode',
  saveError: 'Could not save this address.',
  areaLocked: 'This delivery area is fixed for this order.',
  loading: 'Loading addresses…',
} as const

export type SavedAddress = {
  id: string
  recipientName: string
  recipientPhone: string
  address: string
  city: string
  pincode: string | null
  lat: number | null
  lng: number | null
}

export type AddressDraft = {
  recipientName: string
  recipientPhone: string
  address: string
  city: string
  pincode: string
  lat?: number
  lng?: number
}

export type AddressEditorState = AddressDraft & {
  id: string
}

export type SavedAddressListProps = {
  addresses: SavedAddress[]
  selectedId: string | null
  disabled?: boolean
  onSelect: (id: string | null) => void
}

export type AddressEditorProps = {
  editor: AddressEditorState
  saving: boolean
  error: string | null
  onChange: (patch: Partial<AddressDraft>) => void
  onCancel: () => void
  onSave: () => void
}
